// extracted by mini-css-extract-plugin
export default {"tabNavBarContainer":"Bgw5Tf","tabNavBarItemsContainer":"sknLsd","tabNavBarItem":"goDhYT","selected":"XYEVCY","indicator":"wjwjO6"};